import React from "react";
import Link from "helpers/link";
import formatVehicleType from "helpers/format-vehicle-type";

import navigate from "@helpers/link-navigate";

const CollectionHeader = ({ products, isNewCollectionPageDesign }) => {
    const getCollectionTitle = () => { 
        const vehicleType = products[0]?.vehicle_type;
        if (vehicleType) { 
            const type = products[0]?.vehicle_subtype === "generic" ? formatVehicleType(vehicleType) : formatVehicleType(products[0]?.vehicle_subtype);

            return `${products[0]?.checkout_attributes?.FITS} ${type} Covers`;
        }

        return products[0]?.collection_title;
    };
    if (!products?.length) {
        return (
            <div className={`${isNewCollectionPageDesign ? "collection-item-header " : ""}text-white w-full mt-2 md:my-6`}>
                <div className="bg-blue-700 rounded-t-[3px] px-4 pt-4 pb-7 md:flex md:py-3 md:px-7">
                    <div className="w-full">
                        <div className="collections-header">
                            <h1 className="text-xxl leading-normal mb-0 capitalize md:leading-7 md:text-2xl">
                                <span className="block text-base-xs md:pb-1">
                                    We have 0 items items in this collection
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="w-full pt-5 md:max-w-[16rem] md:text-right md:pt-0">
                        <Link to="/" className="inline-block pt-1.5 text-right italic text-xs lg:pt-0">
                            {isNewCollectionPageDesign ? "" : "←"}
                            Back to home
                        </Link>
                    </div>
                </div>
            </div>
        ); 
    } 

    return (
        <div className={`${isNewCollectionPageDesign ? "collection-item-header " : ""}text-white w-full mt-2 md:my-6`}>
            <div className="bg-blue-700 rounded-t-[3px] px-4 pt-4 pb-7 md:flex md:py-3 md:px-7">
                <div className="w-full">
                    <div className="collections-header">
                        <h1 className="text-xxl leading-normal mb-0 capitalize md:leading-7 md:text-2xl">
                            <span className="block text-base-xs md:pb-1">
                                {`We have ${products?.length} items that fits your `}
                            </span>
                            {getCollectionTitle()}
                        </h1>
                    </div>
                </div>
                <div className="w-full pt-5 md:max-w-[16rem] md:text-right md:pt-0">
                    <button type="button" onClick={() => navigate(-1)} className="inline-block pt-1.5 text-right italic text-xs lg:pt-0">
                        {isNewCollectionPageDesign ? "" : "←"}
                        Back to search
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CollectionHeader;
